import { render, staticRenderFns } from "./notes_history.vue?vue&type=template&id=1d2abd04"
import script from "./notes_history.vue?vue&type=script&lang=js"
export * from "./notes_history.vue?vue&type=script&lang=js"
import style0 from "./notes_history.vue?vue&type=style&index=0&id=1d2abd04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports